import React from "react";
import { useTranslation } from "react-i18next";

import {
  IcoClock,
  IcoDone,
  IcoStar,
  IcoWarning,
  Label
} from "components/generic";
import { TVerify } from "interfaces/interfaces";

import { theme } from "styles/theme";
import { NotVerification } from "./styles";

export const HostVerify: React.FC<{
  verification_status: TVerify | "experienced" | undefined;
  showLabel?: boolean;
  onClick?: () => void;
  chat_environment?: boolean;
  fontSize?: string;
  customMargin?: string;
}> = ({
  verification_status = "unverified",
  showLabel = true,
  onClick,
  chat_environment = false,
  fontSize = "inherit",
  customMargin = "inherit"
}) => {
  const { t } = useTranslation("hostVerify");
  return (
    <NotVerification
      state={verification_status}
      style={{ margin: customMargin }}
      onClick={() => {
        if (onClick) onClick();
      }}
      title={t(`verifyStatus.${verification_status}.title`)}
    >
      {showLabel && (
        <Label
          fontColor="white"
          bgColor={theme.colors.thirdly}
          style={{
            zIndex: 1
          }}
        >
          {chat_environment && verification_status === "verified"
            ? t(`verifyStatus.${verification_status}.chat_tooltip`)
            : t(`verifyStatus.${verification_status}.tooltip`)}
        </Label>
      )}
      <>
        {(verification_status === "unverified" ||
          verification_status === "failed") && <IcoWarning size="1.4em" />}
        {verification_status === "verifying" && (
          <IcoClock size="1.4em" color={theme.colors.thirdly} />
        )}
        {verification_status === "verified" && (
          <IcoDone size="1.4em" color={theme.colors.text} />
        )}
        {verification_status === "experienced" && (
          <IcoStar size="1.4em" color={theme.colors.text} />
        )}
      </>
      <span className="status-title" style={{ fontSize: fontSize }}>
        {chat_environment && verification_status === "verified"
          ? t(`verifyStatus.${verification_status}.chat_verified`)
          : t(`verifyStatus.${verification_status}.title`)}
      </span>
    </NotVerification>
  );
};
